<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="6" sm="12" md="6">
          <DosageGrowth  />
        </v-col>
        <v-col cols="6" sm="12" md="6">
          <DosagePestisides  />
        </v-col>
        <v-col cols="6" sm="12" md="6" >
          <DosageFertilizer />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DosageFertilizer from "./DosageFertilizer";
import DosagePestisides from "./DosagePestisides";
import DosageGrowth from "./DosageGrowth";

export default {
  components: {
    DosageFertilizer,
    DosagePestisides,
    DosageGrowth
  }
};
</script>
